import axios from 'axios';

/**
 * The one client for short lived share links, for every kind of resource.
 *
 * The backend decides what a kind is and what its public page looks like (see
 * backend/ShareResources.js), so nothing here is certificate specific: to
 * share something new, register the kind on the server and pass it in.
 */

// Mirrors the endpoint resolution used in Redux/AdminReducer/action.js
const getEndpoint = () =>
  window.location.protocol === 'http:'
    ? 'http://localhost:5001'
    : `https://${window.location.host}/api`;

const authHeaders = () => {
  try {
    const userData = JSON.parse(sessionStorage.getItem('clinic-application-jwt'));
    return userData?.token ? { Authorization: `Bearer ${userData.token}` } : {};
  } catch (e) {
    return {};
  }
};

// Every link expires; staff only choose how soon.
export const SHARE_EXPIRY_OPTIONS = [
  { value: 15, label: '15 minutes' },
  { value: 60, label: '1 hour' },
  { value: 360, label: '6 hours' },
  { value: 1440, label: '24 hours' },
  { value: 10080, label: '7 days' },
];

/* ------------------------------ clinic staff ------------------------------ */

/** The link currently in circulation for a resource, or null. */
export const fetchActiveShareLink = async (kind, resourceId) => {
  const res = await axios.get(`${getEndpoint()}/share/${kind}/${resourceId}`, {
    headers: authHeaders(),
    params: { origin: window.location.origin },
  });
  return res?.data?.data || null;
};

export const createShareLink = async (kind, resourceId, payload = {}) => {
  const res = await axios.post(
    `${getEndpoint()}/share/${kind}/${resourceId}`,
    { origin: window.location.origin, ...payload },
    { headers: authHeaders() }
  );
  return res?.data?.data;
};

export const revokeShareLink = async (shareId) => {
  const res = await axios.post(`${getEndpoint()}/share/link/${shareId}/revoke`, {}, {
    headers: authHeaders(),
  });
  return res?.data;
};

export const sendShareLink = async (shareId, payload = {}) => {
  const res = await axios.post(
    `${getEndpoint()}/share/link/${shareId}/send`,
    { origin: window.location.origin, ...payload },
    { headers: authHeaders() }
  );
  return res?.data;
};

/* ========================= patient side (no login) ======================= */

/** Resolves any share token into the resource behind it, whatever its kind. */
export const fetchSharedResource = async (token) => {
  const res = await axios.get(`${getEndpoint()}/share/public/${token}`);
  return res?.data?.data;
};
